import React from "react";
import SidebarLayout from "../../Components/Layout/SidebarLayout";
import AIAutomarker from "../../Components/HighLevelComponents/AIAutomarker/AIAutomarker";

const AutomarkerPage: React.FC = () => {
  return (
    <SidebarLayout>
      <AIAutomarker />
    </SidebarLayout>
  );
};

export default AutomarkerPage;
